(function () {
  'use strict';

  function initGallery(wrapper) {
    if (!wrapper || wrapper.dataset.galleryInitialized === 'true') {
      return;
    }
    wrapper.dataset.galleryInitialized = 'true';

    var grid = wrapper.querySelector('[data-gallery-grid]');
    var loadMoreBtn = wrapper.querySelector('[data-load-more]');
    var modal = wrapper.querySelector('[data-gallery-modal]');

    if (!grid || !modal) {
      return;
    }

    var modalImage = modal.querySelector('[data-modal-image]');
    var modalClose = modal.querySelector('[data-modal-close]');
    var modalPrev = modal.querySelector('[data-modal-prev]');
    var modalNext = modal.querySelector('[data-modal-next]');
    var currentImageEl = modal.querySelector('[data-current-image]');
    var totalImagesEl = modal.querySelector('[data-total-images]');

    var loadCount = parseInt(wrapper.dataset.loadCount, 10) || 12;
    var visibleCount = loadCount;

    var allItems = Array.prototype.slice.call(grid.querySelectorAll('.gallery-item'));
    var images = [];
    var currentIndex = 0;

    function updateGallery() {
      allItems.forEach(function (item, index) {
        item.style.display = index < visibleCount ? '' : 'none';
      });

      if (loadMoreBtn) {
        if (visibleCount >= allItems.length) {
          loadMoreBtn.classList.add('hidden');
        } else {
          loadMoreBtn.classList.remove('hidden');
        }
      }
    }

    function getVisibleImages() {
      return allItems.slice(0, visibleCount).map(function (item) {
        var img = item.querySelector('img');
        return img ? (img.dataset.full || img.src) : '';
      });
    }

    function showImage(index) {
      images = getVisibleImages();

      if (!images.length) {
        return;
      }

      if (index < 0) {
        index = images.length - 1;
      }

      if (index >= images.length) {
        index = 0;
      }

      currentIndex = index;

      modalImage.src = images[currentIndex];

      if (currentImageEl) currentImageEl.textContent = currentIndex + 1;
      if (totalImagesEl) totalImagesEl.textContent = images.length;
    }

    function openModal(index) {
      showImage(index);
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    }

    updateGallery();

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        visibleCount += loadCount;
        updateGallery();
      });
    }

    allItems.forEach(function (item, index) {
      item.addEventListener('click', function () {
        if (index >= visibleCount) {
          return;
        }
        openModal(index);
      });
    });

    if (modalNext) {
      modalNext.addEventListener('click', function () {
        showImage(currentIndex + 1);
      });
    }

    if (modalPrev) {
      modalPrev.addEventListener('click', function () {
        showImage(currentIndex - 1);
      });
    }

    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!modal.classList.contains('active')) {
        return;
      }
      if (event.key === 'ArrowRight') {
        showImage(currentIndex + 1);
      }
      if (event.key === 'ArrowLeft') {
        showImage(currentIndex - 1);
      }
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  }

  function initAllGalleries(container) {
    var root = container || document;
    var wrappers = root.querySelectorAll
      ? root.querySelectorAll('.image-gallery-wrapper')
      : [];
    Array.prototype.forEach.call(wrappers, initGallery);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllGalleries(document);
  });

  // Re-init when a merchant adds/reloads this section in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initAllGalleries(event.target);
  });
})();
